import React, { useContext } from "react";
import { Alert } from "react-bootstrap";
import UserContext from "../../../contexts/UserContext";
import { isAdvancedPlan } from "../../../utils/PlanUtils";

const TrainingAccessControl = ({ children, requireManagement = false }) => {
  const { user } = useContext(UserContext);

  // Verificar se o usuário tem permissões básicas de treinamento
  const hasBasicAccess = () => {
    return user && user.account_type && true;
  };

  // Verificar se o usuário pode gerenciar treinamentos (criar/editar vídeos)
  const hasManagementAccess = () => {
    return user && user.account_type && (isAdvancedPlan(user.plan_id));
  };

  // Se requer gerenciamento mas usuário não tem permissão
  if (requireManagement && !hasManagementAccess()) {
    return (
      <div className="container mt-4">
        <Alert variant="warning">
          <h5>Acesso Restrito</h5>
          <p>
            Apenas usuários com conta <strong>Criador</strong> ou <strong>Agência</strong> podem 
            criar e gerenciar conteúdo de treinamentos.
          </p>
          <p className="mb-0">
            Usuários com conta <strong>Empresa</strong> podem apenas assistir aos treinamentos 
            disponibilizados por suas contas pais.
          </p>
        </Alert>
      </div>
    );
  }

  // Se não tem acesso básico
  if (!hasBasicAccess()) {
    return (
      <div className="container mt-4">
        <Alert variant="danger">
          <h5>Acesso Negado</h5>
          <p className="mb-0">
            Você não tem permissão para acessar o módulo de treinamentos.
          </p>
        </Alert>
      </div>
    );
  }

  // Se tem acesso, renderizar o conteúdo
  return children;
};

export default TrainingAccessControl;